import * as React from 'react';
import AspectRatio from '@mui/joy/AspectRatio';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
// import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import IconButton from '@mui/joy/IconButton';
// import Textarea from '@mui/joy/Textarea';
import Stack from '@mui/joy/Stack';
// import Select from '@mui/joy/Select';
// import Option from '@mui/joy/Option';
import Typography from '@mui/joy/Typography';
// import Tabs from '@mui/joy/Tabs';
// import TabList from '@mui/joy/TabList';
// import Tab, { tabClasses } from '@mui/joy/Tab';
// import Breadcrumbs from '@mui/joy/Breadcrumbs';
// import Link from '@mui/joy/Link';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';

// import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
// import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
// import AccessTimeFilledRoundedIcon from '@mui/icons-material/AccessTimeFilledRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import useUser from './auth/useUser';
import { Avatar } from '@mui/joy';
import { gql, useMutation } from '@apollo/client';
import { useFeedback } from './feedback/Service';
import { getCdnFileUrl, parseGraphQLError } from '../utils';

// import CountrySelector from './CountrySelector';
// import EditorToolbar from './EditorToolbar';

const UPLOAD_AVATAR = gql`
  mutation UploadAvatar($blob: Upload!) {
    avatarUpload(blob: $blob)
  }
`;

const UPDATE_ME = gql`
  mutation UpdateMe($user: UserInput!) {
    updateMe(user: $user) {
      _id
      firstName
      lastName
      avatarUrl
    }
  }
`;

let initialState = {
  firstName: '',
  lastName: '',
  avatarUrl: '',
}

// const numericFields = [];

const reducer = (state, newState) => ({
  ...state,
  ...newState
})

export default function Account() {
  const { user } = useUser();
  const [state, setState] = React.useReducer(reducer, initialState);
  const [uploadAvatar, { loading: uploading }] = useMutation(UPLOAD_AVATAR);
  const [updateMe, { loading: posting }] = useMutation(UPDATE_ME);
  const feedback = useFeedback();

  const handleChange = ({ target: { name, value } }) => setState({ [name]: value });

  const uploadImage = async (file) => {
    try {
      const { data: { avatarUpload } } = await uploadAvatar({
        variables: { blob: file },
      });
      return avatarUpload;
      // console.log("pdfUpload", getCdnFileUrl(pdfUpload));
    } catch (error) {
      console.error("upload error", error);
      feedback.snackbar({ text: "Upload error", type: "error" });
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { ...state };
      const updatedUser = await updateMe({
        variables: {
          user: {
            firstName: data.firstName,
            lastName: data.lastName,
            avatarUrl: data.avatarUrl
          }
        },
      });
      console.log("updatedUser", updatedUser);
      feedback.snackbar({ text: "Changes saved!", type: "success" });
    } catch (error) {
      console.error("Account error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      feedback.snackbar({ text: "No file selected", type: "warning" });
      return;
    }
    if (file.size > 300 * 1024) { // 300 KB
      feedback.snackbar({ text: "File size exceeds 300 KB", type: "error" });
      return;
    }
    console.log("file", file);
    try {
      const avatarUrl = await uploadImage(file);
      console.log("avatarUrl", avatarUrl);
      const updatedUser = await updateMe({
        variables: {
          user: {
            firstName: user.firstName,
            lastName: user.lastName,
            avatarUrl: avatarUrl,
          }
        },
      });
      console.log("updatedUser", updatedUser);
    } catch (error) {
      console.error("File upload error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
    e.target.value = ''; // Reset file input
  }

  React.useEffect(() => {
    if (user) {
      setState({
        firstName: user.firstName,
        lastName: user.lastName,
        avatarUrl: user.avatarUrl,
      });
    }
  }, [user]);

  return (
    <>
      <Box
        component="main"
        sx={{
          my: 'auto',
          py: 2,
          pb: 5,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: "100%",
          maxWidth: 'sm',
          mx: 'auto',
          borderRadius: 'sm',
          '& form': {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          },
          // [`& .MuiFormLabel-asterisk`]: {
          //   visibility: 'hidden',
          // },
        }}
      >
        <Card>
          <Box sx={{ mb: 1 }}>
            <Typography level="title-md">Account</Typography>
            <Typography level="body-sm">
              General information about your account
            </Typography>
          </Box>
          <Divider />
          <Stack
            direction="column"
            spacing={2}
            sx={{ display: { xs: 'flex', md: 'flex' }, my: 1 }}
          >
            <Stack direction="row" spacing={2}>
              <Stack direction="column" spacing={1}>
                <AspectRatio
                  ratio="1"
                  maxHeight={108}
                  sx={{ flex: 1, minWidth: 108, borderRadius: '100%' }}
                >
                  {/* {state.avatarUrl ?
                    <img
                      src={getCdnFileUrl(state.avatarUrl)}
                      loading="lazy"
                      alt=""
                    /> :
                    <Avatar />
                  } */}
                  <Avatar src={state.avatarUrl ? getCdnFileUrl(state.avatarUrl) : undefined} alt={`${state.firstName} ${state.lastName}`} />
                </AspectRatio>
                <IconButton
                  aria-label="upload new picture"
                  size="sm"
                  variant="outlined"
                  color="neutral"
                  component="label"
                  loading={uploading}
                  role={undefined}
                  tabIndex={-1}
                  sx={{
                    bgcolor: 'background.body',
                    position: 'absolute',
                    zIndex: 2,
                    borderRadius: '50%',
                    left: 85,
                    top: 180,
                    boxShadow: 'sm',
                  }}
                >
                  <EditRoundedIcon />
                  <input type="file" style={{ display: 'none' }} accept="image/*" onChange={handleFileChange} />
                </IconButton>
              </Stack>
              <form id='account-form' onSubmit={handleSubmit}>
                <Stack spacing={1} sx={{ flexGrow: 1 }}>
                  <FormLabel>Name</FormLabel>
                  <FormControl
                    sx={{
                      display: {
                        sm: 'flex-column',
                        md: 'flex-row',
                      },
                      // gap: 2,
                    }}
                  >
                    <Input size="sm" placeholder="First name" value={state.firstName} name="firstName" onChange={handleChange} />
                  </FormControl>
                  <FormControl
                    sx={{
                      display: {
                        sm: 'flex-column',
                        md: 'flex-row',
                      },
                      // gap: 2,
                    }}
                  >
                    <Input size="sm" placeholder="Last name" value={state.lastName} name="lastName" onChange={handleChange} />
                  </FormControl>
                </Stack>
              </form>
            </Stack>
            <FormControl sx={{ flexGrow: 1 }}>
              <FormLabel>Email</FormLabel>
              <Input
                size="sm"
                type="email"
                startDecorator={<EmailRoundedIcon />}
                placeholder="email"
                value={user.email}
                sx={{ flexGrow: 1 }}
                readOnly
              />
            </FormControl>
          </Stack>
          <CardOverflow sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
            <CardActions sx={{ alignSelf: 'flex-end', pt: 2 }}>
              {/* <Button size="sm" variant="outlined" color="neutral">
                Cancel
              </Button> */}
              <Button size="sm" variant="solid" form="account-form" type='submit' loading={posting}>
                Save
              </Button>
            </CardActions>
          </CardOverflow>
        </Card>
      </Box >
    </>
  );
}
